<div class="cg-search-wrapper">
  <div class="cg-search-container" [ngClass]="{closed: (searchExpanded$ | async) === false}">
    <div class="cg-search-background"></div>
    <div class="cg-search-icon-container">
      <button class="cg-search-open-btn"
              (click)="expandSearch()"
              [tabindex]="(searchExpanded$ | async) === false ? 1 : -1"
              aria-label="Open Search">
        <i class="fa fa-search" aria-hidden="true" (click)="expandSearch()"></i>
      </button>
    </div>
    <div class="cg-search-input-container">
      <button class="cg-search-close-btn"
              (click)="collapseSearch()"
              [tabindex]="(searchExpanded$ | async) === true ? 3 : -1"
              aria-label="Cancel Search">
        <i class="eleot-icon icon-close" (click)="collapseSearch()"></i>
      </button>
      <input pInputText
             #cgSearchInput
             type="text"
             [placeholder]="placeholderText"
             [(ngModel)]="searchStringRaw"
             (keyup)="onSearchTextKeyUp()"
             [tabindex]="(searchExpanded$ | async) === true ? 2 : -1"
             aria-label="Search"
      />
    </div>
  </div>
</div>

